var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},_vm._l((_vm.attributes),function(attribute,idx){return _c('sidebar-checkbox-filter',_vm._b({key:idx},'sidebar-checkbox-filter',attribute,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }